<div *ngIf="prFormCustomDetails" class="purchase-request-form-wrapper"
     [ngStyle]="!prFormCustomDetails?.formEnabled ? {'height':'100%'} : {} ">
  <div class="purchase-request-form-inner-wrapper"
       [ngStyle]="!prFormCustomDetails?.formEnabled ? {'width':'100%'} : {} ">
    <div class="purchase-request-form-header" [ngStyle]="{ 'background-color': prFormCustomDetails.formColor }">
      <div class="purchase-request-form-header-texts">
        <h1 class="purchase-request-form-header-title">{{prFormCustomDetails?.formTitle}}</h1>
        <h2 class="purchase-request-form-header-subTitle">{{prFormCustomDetails?.formSubtitle}}</h2>
      </div>
      <img *ngIf="prFormCustomDetails?.logoType && prFormCustomDetails?.logoType != 'NO_LOGO'"
           class="purchase-request-form-logo" src={{prFormCustomDetails?.selectedLogoPath}} alt={{logoLabel}}>
    </div>
    <div class="inactive-form-section" *ngIf="!prFormCustomDetails?.formEnabled" role="region" aria-labelledby="banner">
      <ng-container *ngTemplateOutlet="formInactive">
      </ng-container>
    </div>
    <div *ngIf="prFormCustomDetails?.formEnabled" class="purchase-request-form-fields-wrapper">
      <!--  ===============Subscription Box=============== -->
      <div *ngIf="openSubBanner" role="region" aria-labelledby="banner">
        <ng-container *ngTemplateOutlet=" isSucSubmit ? sucSubBanner : failSubBanner">
        </ng-container>
      </div>
      <!--  ====================================== -->

      <div class="purchase-request-form-header-text-wrapper">
        <div class="purchase-request-form-header-text"
             [innerHtml]="prFormCustomDetails?.formHeaderText?.length > 0 ?  sanitizer.bypassSecurityTrustHtml(prFormCustomDetails.formHeaderText) : ''"></div>
      </div>
      <form *ngIf="PRForm" [formGroup]="PRForm" (ngSubmit)="onSubmit(PRForm.value)" #formDirective="ngForm">
        <div style="display: flex; width: 100%;" class="purchase-request-form-requested-format-field-wrapper">

          <div *ngIf="(prFormCustomDetails.displayElectronic || prFormCustomDetails.displayPhysical)"
               class="purchase-request-form-requested-format-wrapper">
            <span id="requested-format"
                  class="purchase-request-form-requested-format-field-label">{{requestedFormat}}</span>

            <mat-radio-group aria-labelledby="requested-format-label" formControlName="format.value"
                             style="display: flex; width: 100%;">
              <div *ngIf="prFormCustomDetails.displayElectronic" class="purchase-request-form-requested-format sel-e-format">
                <mat-radio-button id="format-electronic"   value="E"
                                  aria-labelledby="format-electronic-label" [disabled]="!prFormCustomDetails.displayPhysical"></mat-radio-button>
                <label  for="format-electronic" id="format-electronic-label">{{ electronic }}</label>
              </div>
              <div *ngIf="prFormCustomDetails.displayPhysical" class="purchase-request-form-requested-format sel-p-format">
                <mat-radio-button id="format-physical" value="P"
                                  aria-labelledby="format-physical-label" [disabled]="!prFormCustomDetails.displayElectronic"></mat-radio-button>
                <label for="format-physical" id="format-physical-label">{{ physical }}</label>
              </div>
            </mat-radio-group>

          </div>
        </div>

        <div class="purchase-request-form-respoonsive-wrapper">
          <ng-container *ngFor="let field of fields">
            <ng-container [ngSwitch]="field.fieldType">
              <mat-form-field style="width: calc(50% - 20px);" *ngSwitchCase="'number'">
                <mat-label>{{field.label}}</mat-label>
                <input matInput [required]="field.isMandatory" type="number"
                       [formControlName]="field.fieldName" [ngClass]="'sel-form-' + field.selLabel">
                <mat-error>
                  <ng-template  [ngTemplateOutlet]="txtErrorMessages" [ngTemplateOutletContext]="{ control: PRForm.controls[field.fieldName] }"></ng-template>
                </mat-error>
              </mat-form-field>
              <mat-form-field style="width: calc(50% - 20px);" *ngSwitchCase="'long'">
                <mat-label>{{field.label}}</mat-label>
                <input matInput [required]="field.isMandatory"
                       [formControlName]="field.fieldName" [ngClass]="'sel-form-' + field.selLabel">
                <mat-error>
                  <ng-template  [ngTemplateOutlet]="txtErrorMessages" [ngTemplateOutletContext]="{ control: PRForm.controls[field.fieldName] }"></ng-template>
                </mat-error>
                <mat-error *ngIf="field.fieldName == 'resource_metadata.isbn' && PRForm.controls['resource_metadata.isbn'].errors?.isbn">{{invalidIsbnError}}</mat-error>
              </mat-form-field>

              <ng-container *ngIf="field.fieldName ==='resource_metadata.requestor_name'">
                <mat-form-field style="width: calc(100% - 20px); " *ngSwitchCase=" 'text' ">
                  <mat-icon matPrefix>account_circle</mat-icon>
                  <mat-label>{{field.label}}</mat-label>
                  <input type="text" matInput [required]="field.isMandatory"
                         formControlName="name" [ngClass]=" 'sel-form-' + field.selLabel" autocomplete="given-name">
                  <mat-error *ngIf="PRForm.controls['name'].errors?.pattern">{{invalidNameError}}</mat-error>
                  <mat-error *ngIf="PRForm.controls['name'].errors?.required">{{missingNameError}}</mat-error>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="field.fieldName ==='resource_metadata.requestor_email' && emailRegexFetched">
                <mat-form-field style="width: calc(100% - 20px); " *ngSwitchCase=" 'text' ">
                  <mat-icon matPrefix>mail</mat-icon>
                  <mat-label>{{field.label}}</mat-label>
                  <input type="email" matInput [required]="field.isMandatory"
                         formControlName="email" [ngClass]=" 'sel-form-' + field.selLabel" autocomplete="email" email>
                  <mat-error *ngIf="PRForm.controls['email'].errors?.email">{{invalidEmailError}}
                  </mat-error>
                  <mat-error *ngIf="PRForm.controls['email'].errors?.required">{{missingEmailError}}</mat-error>
                </mat-form-field>
              </ng-container>
              <ng-container
                *ngIf="field.fieldName !='resource_metadata.requestor_name' && field.fieldName !='resource_metadata.requestor_email'">
                <mat-form-field style="width: calc(100% - 20px); " *ngSwitchCase=" 'text' ">
                  <mat-label>{{field.label}}</mat-label>
                  <input matInput [required]="field.isMandatory"
                         [formControlName]="field.fieldName " [ngClass]=" 'sel-form-' + field.selLabel">
                  <mat-error>
                    <ng-template  [ngTemplateOutlet]="txtErrorMessages" [ngTemplateOutletContext]="{ control: PRForm.controls[field.fieldName] }"></ng-template>
                  </mat-error>
                </mat-form-field>
              </ng-container>
              <mat-form-field style="width: calc(50% - 20px);" *ngSwitchCase="'date'">
                <mat-label>{{field.label}}</mat-label>
                <input matInput [matDatepicker]="picker" aria-labelledby="field.label"
                       aria-required="field.isMandatory" [required]="field.isMandatory"
                       [formControlName]="field.fieldName" [ngClass]="'sel-form-' + field.selLabel">
                <mat-error>
                  <ng-template  [ngTemplateOutlet]="txtErrorMessages" [ngTemplateOutletContext]="{ control: PRForm.controls[field.fieldName] }"></ng-template>
                </mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker startView="multi-year" panelClass="purchase-request-form-date-picker"
                                (yearSelected)="yearSelectedHandler($event, picker)"
                                (opened)="onDatePickerOpened()"></mat-datepicker>
              </mat-form-field>

              <mat-form-field *ngSwitchDefault>
                <mat-label>{{field.label}}</mat-label>
                <input matInput [required]="field.isMandatory"
                       [formControlName]="field.fieldName" [ngClass]="'sel-form-' + field.selLabel">
                <mat-error>
                  <ng-template  [ngTemplateOutlet]="txtErrorMessages" [ngTemplateOutletContext]="{ control: PRForm.controls[field.fieldName] }"></ng-template>
                </mat-error>
              </mat-form-field>
            </ng-container>
          </ng-container>
        </div>


        <div role="region" aria-labelledby="subscription">
          <button
            [ngStyle]="{ 'background-color': PRForm.valid ? prFormCustomDetails.formColor : '#00000042', 'color': PRForm.valid ? blackOrWhiteText : null }"
            [disabled]="!PRForm.valid || isSubmitting"
            class="purchase-request-form-submit-button sel-form-submit-button"
            mat-raised-button
            type="submit"
            color="primary"
            [attr.aria-label]="isSubmitting ? 'Submitting...' : 'Submit Request'"
            [attr.aria-live]="isSubmitting ? 'assertive' : 'polite'"
          >
            {{ submitRequest }}
            <mat-icon *ngIf="isSubmitting">
              <mat-spinner class="purchase-request-form-spinner" [diameter]="20"></mat-spinner>
            </mat-icon>
          </button>
        </div>
      </form>
    </div>

    <div *ngIf="prFormCustomDetails?.formEnabled" class="purchase-request-form-footer">
      <div class="purchase-request-form-footer-text"
           [innerHtml]="prFormCustomDetails?.formFooterText?.length > 0 ?  sanitizer.bypassSecurityTrustHtml(prFormCustomDetails.formFooterText) : ''"></div>
    </div>
  </div>


</div>

<ng-template #sucSubBanner>
  <div class="pr-form-sub-box success-box" aria-label="Submission succeeded">
    <i class="material-icons pr-form-sub-success-icon">
      check_circle
    </i>
    <div class="pr-form-sub-box-info" role="alert" aria-live="assertive" aria-atomic="true">
      <span class="pr-form-sub-box-title">{{ subSucBoxInfo }}</span>
      <p>
      </p>
    </div>
    <button mat-button class="pr-form-sub-close-icon" (click)="closeBanner()">
      <mat-icon [ngStyle]="{'font-size': '20px', height: '20px', width: '20px'}" icon>close</mat-icon>
    </button>
  </div>
</ng-template>
<ng-template #failSubBanner>
  <div class="pr-form-sub-box fail-box" aria-label="Submission failed">
    <i class="material-icons pr-form-sub-fail-icon">
      error
    </i>
    <div class="pr-form-sub-box-info" role="alert" aria-live="assertive" aria-atomic="true">
                        <span
                          class="pr-form-sub-box-title">{{subFailBoxInfo}}
                        </span>
      <p>
    </div>
    <button mat-button class="pr-form-sub-close-icon" (click)="closeBanner()">
      <mat-icon [ngStyle]="{'font-size': '20px', height: '20px', width: '20px'}" icon>close</mat-icon>
    </button>

  </div>

</ng-template>

<ng-template #txtErrorMessages let-control="control">
  <span *ngIf="control.touched && control.invalid && control.errors?.pattern">{{txtIsBlankError}}</span>
  <span *ngIf="control.touched && control.invalid && control.errors?.required">{{fieldIsMandatoryError}}</span>
</ng-template>


<ng-template #formInactive>
  <div class="pr-form-sub-box inactive-box">
    <i class="material-icons pr-form-sub-fail-icon">
      cancel
    </i>
    <div class="pr-form-sub-box-info">
                        <span
                          class="pr-form-sub-box-title">{{formInactiveBoxInfo}}
                        </span>
      <p>
    </div>

  </div>

</ng-template>
